/* =========================================================
   Body Wave Buy Box
   - Multi-option variant resolver (option1 × option2 × option3)
   - Matrix-aware: disables values that have no available combo
     given the current selections of OTHER options
   - LOCAL ONLY: no URL change, no global event dispatch
   - Loox left untouched (its own injector handles widgets)
   ========================================================= */
(function () {
  'use strict';

  function init(section) {
    if (section.dataset.bwhBound === '1') return;
    section.dataset.bwhBound = '1';

    var variantsScript = section.querySelector('[data-bwh-variants]');
    var configScript = section.querySelector('[data-bwh-config]');
    if (!variantsScript) return;

    var variants;
    var config;
    try {
      variants = JSON.parse(variantsScript.textContent);
      config = configScript ? JSON.parse(configScript.textContent) : {};
    } catch (e) { return; }

    var lowStockThreshold = (config && config.lowStockThreshold) || 3;

    var hero = section.querySelector('[data-bwh-hero]');
    var heroBtn = hero ? hero.closest('[data-bwh-zoom-trigger]') : null;
    var hiddenId = section.querySelector('[data-bwh-variant-id]');
    var priceEl = section.querySelector('[data-bwh-price]');
    var compareEl = section.querySelector('[data-bwh-compare]');
    var afterpayAmt = section.querySelector('[data-bwh-afterpay-amt]');
    var cta = section.querySelector('[data-bwh-cta]');
    var ctaPrice = section.querySelector('[data-bwh-cta-price]');
    var ctaLabel = section.querySelector('[data-bwh-cta-label]');
    var stickyName = section.querySelector('[data-bwh-sticky-name]');
    var stickyPrice = section.querySelector('[data-bwh-sticky-price]');
    var stickyCta = section.querySelector('[data-bwh-sticky-cta]');
    var sticky = section.querySelector('[data-bwh-sticky]');
    var stockBlock = section.querySelector('[data-bwh-stock-block]');
    var stockText = section.querySelector('[data-bwh-stock-text]');
    var qtyInput = section.querySelector('[data-bwh-qty-input]');
    var qtyDec = section.querySelector('[data-bwh-qty-dec]');
    var qtyInc = section.querySelector('[data-bwh-qty-inc]');
    var form = section.querySelector('form[action*="/cart/add"]') || section.querySelector('form');

    // Pickers
    var pickerFieldsets = section.querySelectorAll('[data-picker-index]');
    var optionButtons = section.querySelectorAll('[data-bwh-opt]');

    // Initial selections from currently-active variant (resolved server-side)
    var initialId = hiddenId ? parseInt(hiddenId.value, 10) : null;
    var initialVariant = variants.find(function (v) { return v.id === initialId; }) || variants[0];
    var selected = initialVariant ? initialVariant.options.slice() : [];

    function resolveVariant(sel) {
      return variants.find(function (v) {
        return v.options.length === sel.length &&
               v.options.every(function (o, i) { return o === sel[i]; });
      });
    }

    function availableValuesForOption(optIndex, selSnapshot) {
      var set = {};
      variants.forEach(function (v) {
        if (!v.available) return;
        var match = true;
        for (var i = 0; i < v.options.length; i++) {
          if (i === optIndex) continue;
          if (selSnapshot[i] && v.options[i] !== selSnapshot[i]) { match = false; break; }
        }
        if (match) set[v.options[optIndex]] = true;
      });
      return set;
    }

    function refreshPickerStates() {
      pickerFieldsets.forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-picker-index'), 10);
        var available = availableValuesForOption(idx, selected);
        fs.querySelectorAll('[data-bwh-opt]').forEach(function (btn) {
          var val = btn.getAttribute('data-opt-value');
          var isAvail = !!available[val];
          var isActive = selected[idx] === val;
          // 2026-08-08: two different states, and conflating them is what hid Honey Drip.
          // DEAD = sold out on every variant. Greyed and genuinely not tappable.
          // CROSS = buyable, just not alongside the current other selection. Tappable, and
          // tapping it moves the other axis. Marked with a softer class so she can see it
          // will change her length, but never styled to look unavailable, because it is not.
          var isDead = !valueHasAnyAvailable(idx, val);
          var isCross = !isDead && !isAvail && !isActive;
          btn.classList.toggle('is-disabled', isDead);
          btn.classList.toggle('is-cross', isCross);
          btn.setAttribute('aria-disabled', isDead ? 'true' : 'false');
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
        });
        // Update legend value
        var valueLabel = section.querySelector('[data-bwh-picker-value="' + idx + '"]');
        if (valueLabel) valueLabel.textContent = selected[idx] || '';
      });
    }

    function updateStock(variant) {
      if (!stockBlock || !stockText) return;
      if (!variant) {
        stockBlock.setAttribute('data-stock-state', 'out');
        stockText.textContent = 'Not available';
        return;
      }
      if (!variant.available) {
        stockBlock.setAttribute('data-stock-state', 'out');
        stockText.textContent = 'Sold out';
        return;
      }
      if (variant.tracked && variant.inventory_quantity !== null) {
        var q = variant.inventory_quantity;
        if (q <= 0) {
          stockBlock.setAttribute('data-stock-state', 'out');
          stockText.textContent = 'Sold out';
        } else if (q <= lowStockThreshold) {
          stockBlock.setAttribute('data-stock-state', 'low');
          stockText.textContent = q === 1 ? 'Last bundle available' : 'Only a few bundles left';
        } else {
          stockBlock.setAttribute('data-stock-state', 'in');
          stockText.textContent = 'In stock, ready to ship';
        }
      } else {
        stockBlock.setAttribute('data-stock-state', 'in');
        stockText.textContent = 'In stock — ready to ship';
      }
    }

    function updateQtyMax(variant) {
      if (!qtyInput) return;
      var max = 99;
      if (variant && variant.tracked && variant.inventory_quantity !== null && variant.inventory_quantity > 0) {
        max = variant.inventory_quantity;
      }
      qtyInput.max = max;
      var current = parseInt(qtyInput.value, 10) || 1;
      if (current > max) qtyInput.value = max;
      if (current < 1) qtyInput.value = 1;
    }

    function setHero(variant) {
      if (!hero || !variant || !variant.image) return;
      hero.classList.add('is-swapping');
      var preload = new Image();
      preload.onload = function () {
        hero.src = variant.image;
        hero.removeAttribute('srcset');
        hero.alt = variant.image_alt || '';
        hero.classList.remove('is-swapping');
        if (heroBtn && variant.image_zoom) {
          heroBtn.setAttribute('data-zoom-src', variant.image_zoom);
        }
      };
      preload.onerror = function () { hero.classList.remove('is-swapping'); };
      preload.src = variant.image;

      // Snap gallery to slide 0
      var gallery = section.querySelector('[data-bwh-gallery]');
      if (gallery) {
        try { gallery.scrollTo({ left: 0, behavior: 'smooth' }); }
        catch (e) { gallery.scrollLeft = 0; }
      }
    }

    function applyVariant(variant) {
      // Update form id (or null when invalid combo)
      if (hiddenId) hiddenId.value = variant ? variant.id : '';

      // Price + Afterpay instalment
      if (variant) {
        if (priceEl) priceEl.textContent = variant.price_money;
        if (afterpayAmt) afterpayAmt.textContent = variant.installment_money;
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = variant.compare_at_money;
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
      }

      // CTA
      if (cta) {
        var disable = !variant || !variant.available;
        cta.disabled = disable;
        if (disable) cta.setAttribute('aria-disabled', 'true');
        else cta.removeAttribute('aria-disabled');
        if (ctaLabel) {
          if (!variant) {
            ctaLabel.textContent = 'Combination unavailable';
          } else if (!variant.available) {
            ctaLabel.textContent = 'Sold out';
          } else {
            ctaLabel.innerHTML = 'Add to cart · <span data-bwh-cta-price>' + variant.price_money + '</span>';
          }
        }
      }

      // Sticky bar
      if (stickyName && variant) stickyName.textContent = variant.title;
      if (stickyPrice && variant) stickyPrice.textContent = variant.price_money;
      if (stickyCta) {
        var disable2 = !variant || !variant.available;
        stickyCta.disabled = disable2;
        stickyCta.textContent = !variant ? 'Unavailable' : (variant.available ? 'Add to cart' : 'Sold out');
      }

      updateStock(variant);
      updateQtyMax(variant);
      setHero(variant);
    }

    // Does this option value exist on ANY purchasable variant, ignoring what is
    // currently selected on the other axis? This is the difference between "sold out
    // everywhere" (genuinely dead, refuse the tap) and "not available with your current
    // other selection" (perfectly buyable, we just have to move the other axis for her).
    function valueHasAnyAvailable(optIndex, val) {
      return variants.some(function (v) {
        return v.available && v.options[optIndex] === val;
      });
    }

    // pinIndex: the option the customer just tapped. Candidates that do not honour it are
    // rejected outright, otherwise the scoring below can "correct" her straight back to
    // where she started. Without the pin, tapping Honey Drip from 20"/Natural Black scores
    // 20"/Natural Black and 22"/Honey Drip equally (one matching option each) and array
    // order silently undoes the tap.
    function autoCorrectSelections(pinIndex) {
      var v = resolveVariant(selected);
      if (v && v.available) return;
      var best = null;
      var bestScore = -1;
      variants.forEach(function (cand) {
        if (!cand.available) return;
        if (pinIndex != null && cand.options[pinIndex] !== selected[pinIndex]) return;
        var score = 0;
        for (var i = 0; i < cand.options.length; i++) {
          if (i === pinIndex) continue;
          if (cand.options[i] === selected[i]) score++;
        }
        if (score > bestScore) { bestScore = score; best = cand; }
      });
      if (best) selected = best.options.slice();
    }

    // 2026-08-08 DEADLOCK FIX. Founder found it on a TikTok live: "please fix it's costing
    // me money."
    // The guard here used to be `if (btn.getAttribute('aria-disabled') === 'true') return;`
    // which refused every tap on a greyed option. On a two-axis picker that is a deadlock,
    // because each axis greys the other out. Body Wave opened on 20"/Natural Black, where
    // Honey Drip is grey (20" has no Honey Drip) and 22"/24"/26" are grey (Natural Black
    // has no 22"/24", and 26" Natural Black is out of stock). Every route to Honey Drip
    // was blocked by the very selection you had to change to get there.
    // Result: 3 of 7 variants were unreachable. 14 bundles in stock, about $2,470 of
    // Honey Drip, could not be added to cart by anybody.
    // autoCorrectSelections() already existed to handle exactly this and was never allowed
    // to run. Now we only refuse a tap when the value is sold out on every variant; a value
    // that exists elsewhere is honoured and the OTHER axis moves to meet it.
    function handleOptionClick(btn) {
      var idx = parseInt(btn.getAttribute('data-opt-index'), 10);
      var val = btn.getAttribute('data-opt-value');
      if (!valueHasAnyAvailable(idx, val)) return;
      if (selected[idx] === val) return;

      selected[idx] = val;
      autoCorrectSelections(idx);
      refreshPickerStates();
      applyVariant(resolveVariant(selected));
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { handleOptionClick(btn); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOptionClick(btn); }
      });
    });

    // Qty buttons
    function clampQty() {
      var max = parseInt(qtyInput.max, 10) || 99;
      var n = parseInt(qtyInput.value, 10) || 1;
      if (n < 1) n = 1;
      if (n > max) n = max;
      qtyInput.value = n;
    }
    if (qtyDec) qtyDec.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      clampQty();
    });
    if (qtyInc) qtyInc.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      clampQty();
    });
    if (qtyInput) qtyInput.addEventListener('change', clampQty);

    // Sticky CTA → submit form
    if (stickyCta && form) {
      stickyCta.addEventListener('click', function () {
        if (stickyCta.disabled) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }

    // Initial render
    refreshPickerStates();
    applyVariant(resolveVariant(selected));

    // Sticky bar IO
    if (sticky && cta && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', visible);
          sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
      }, { rootMargin: '0px 0px -40% 0px', threshold: 0 });
      io.observe(cta);
    }

    // ----- Gallery dot sync + tap-to-jump -----
    var gallery = section.querySelector('[data-bwh-gallery]');
    var dots = section.querySelectorAll('[data-bwh-dots] .bwh__dot');
    var slides = section.querySelectorAll('.bwh__gallery-slide');
    if (gallery && slides.length > 1 && dots.length === slides.length && 'IntersectionObserver' in window) {
      var slideObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
            var i = parseInt(entry.target.getAttribute('data-slide-index'), 10) || 0;
            dots.forEach(function (d, di) {
              var on = di === i;
              d.classList.toggle('is-active', on);
              d.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            // Customers control playback; pause videos when their slide leaves view.
          } else {
            var v2 = entry.target.querySelector('[data-bwh-video]');
            if (v2) { v2.pause(); }
          }
        });
      }, { root: gallery, threshold: [0, 0.55, 1] });
      slides.forEach(function (s) { slideObserver.observe(s); });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-dot-index'), 10) || 0;
        var t = slides[i];
        if (!gallery || !t) return;
        try { gallery.scrollTo({ left: t.offsetLeft, behavior: 'smooth' }); }
        catch (e) { gallery.scrollLeft = t.offsetLeft; }
      });
    });

    // Reduced-motion → don't autoplay videos
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      section.querySelectorAll('[data-bwh-video]').forEach(function (v) {
        v.removeAttribute('autoplay');
        v.pause();
      });
    }

    // ----- Zoom lightbox -----
    var zoomTriggers = section.querySelectorAll('[data-bwh-zoom-trigger]');
    var lightbox = section.querySelector('[data-bwh-lightbox]');
    var lightboxImg = section.querySelector('[data-bwh-lightbox-img]');
    var lightboxClose = section.querySelector('[data-bwh-lightbox-close]');

    function openZoom(btn) {
      if (!lightbox || !lightboxImg || !btn) return;
      var src = btn.getAttribute('data-zoom-src');
      var img = btn.querySelector('img');
      if (!src && img) src = img.currentSrc || img.src;
      if (!src) return;
      lightboxImg.src = src;
      lightboxImg.alt = img ? img.alt : '';
      lightbox.hidden = false;
      requestAnimationFrame(function () { lightbox.classList.add('is-open'); });
      document.documentElement.classList.add('bwh-no-scroll');
    }
    function closeZoom() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      document.documentElement.classList.remove('bwh-no-scroll');
      setTimeout(function () {
        if (!lightbox.classList.contains('is-open')) {
          lightbox.hidden = true;
          if (lightboxImg) lightboxImg.removeAttribute('src');
        }
      }, 200);
    }
    zoomTriggers.forEach(function (b) { b.addEventListener('click', function () { openZoom(b); }); });
    if (lightboxClose) lightboxClose.addEventListener('click', closeZoom);
    if (lightbox) {
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target.classList.contains('bwh__lightbox-stage')) closeZoom();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox && !lightbox.hidden) closeZoom();
    });
  }

  function boot() {
    document.querySelectorAll('[data-bwh-section]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target.querySelector ? e.target.querySelector('[data-bwh-section]') : null;
      if (sec) init(sec);
    });
  }
})();
